(function () {
  'use strict';

  if (window.SocialLP) return;
  window.SocialLP = {};

  var root = document.documentElement;

  /* ---------- Tracking ---------- */
  function track(name, params) {
    if (!name || typeof window.redmondGa4Tag !== 'function') return;
    var data = { page_path: window.location.pathname };
    if (params) {
      for (var key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) data[key] = params[key];
      }
    }
    window.redmondGa4Tag('event', name, data);
  }
  window.SocialLP.track = track;

  // Capture phase so the event is sent before a form submit or link navigates.
  document.addEventListener('click', function (event) {
    var el = event.target && event.target.closest ? event.target.closest('[data-track]') : null;
    if (!el || !el.closest('.slp')) return;
    track(el.getAttribute('data-track'));
  }, true);

  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item || !item.matches || !item.matches('details[data-lp-faq]') || !item.open) return;
    var question = item.querySelector('summary');
    track('faq_open', { faq_question: question ? question.textContent.trim().slice(0, 100) : '' });
  }, true);

  /* ---------- Cart state ---------- */
  function stickyVariantIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('[data-lp-sticky][data-variant-id]'),
      function (el) { return String(el.getAttribute('data-variant-id')); }
    );
  }

  function setInCart(on) {
    root.classList.toggle('slp-in-cart', !!on);
  }

  function refreshCartState() {
    var ids = stickyVariantIds();
    if (!ids.length) return;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        setInCart(cart.items.some(function (item) {
          return ids.indexOf(String(item.variant_id)) !== -1;
        }));
      })
      .catch(function () {});
  }

  /* ---------- Add to cart ---------- */
  function addToCart(form) {
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? String(idInput.value) : '';
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
        return r.json();
      })
      .then(function (json) {
        if (stickyVariantIds().indexOf(variantId) !== -1) setInCart(true);
        return json;
      })
      .catch(function (err) {
        // Fall back to a normal form post so the shopper still lands on /cart.
        console.error('[Social LP]', err);
        form.dataset.rcdNoAjax = '1';
        form.submit();
        throw err;
      });
  }

  var previousOverride = window.redmondAddToCartOverride;
  window.redmondAddToCartOverride = function (form) {
    if (form && form.hasAttribute && form.hasAttribute('data-lp-form')) {
      return addToCart(form);
    }
    return typeof previousOverride === 'function' ? previousOverride.apply(this, arguments) : null;
  };

  // When the cart drawer closes, the shopper may have removed the offer.
  function watchCartDrawer() {
    var overlay = document.getElementById('rcd-overlay');
    if (!overlay || !window.MutationObserver) return;
    var wasOpen = overlay.classList.contains('is-open');
    new MutationObserver(function () {
      var isOpen = overlay.classList.contains('is-open');
      if (wasOpen && !isOpen) refreshCartState();
      wasOpen = isOpen;
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Sticky bar ---------- */
  var stickyObserver = null;

  function setStickyHidden(bar, hidden) {
    bar.classList.toggle('is-hidden', hidden);
    bar.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    bar.inert = hidden;
  }

  function initSticky() {
    if (stickyObserver) {
      stickyObserver.disconnect();
      stickyObserver = null;
    }

    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-lp-sticky]'));
    if (!bars.length) return;

    var ctas = document.querySelectorAll('[data-lp-cta]');
    var watchCtas = bars.some(function (bar) {
      return bar.getAttribute('data-hide-near-cta') === 'true';
    });

    if (!watchCtas || !ctas.length || !('IntersectionObserver' in window)) {
      bars.forEach(function (bar) { setStickyHidden(bar, false); });
      return;
    }

    var onScreen = [];
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var i = onScreen.indexOf(entry.target);
        if (entry.isIntersecting && i === -1) onScreen.push(entry.target);
        if (!entry.isIntersecting && i !== -1) onScreen.splice(i, 1);
      });
      bars.forEach(function (bar) {
        var hideNearCta = bar.getAttribute('data-hide-near-cta') === 'true';
        setStickyHidden(bar, hideNearCta && onScreen.length > 0);
      });
    });

    Array.prototype.forEach.call(ctas, function (cta) { stickyObserver.observe(cta); });
  }

  /* ---------- Live Yotpo reviews ---------- */
  // Refreshes score, count and star breakdown from Yotpo's storefront API (the
  // same numbers the product page shows). The server-rendered numbers from
  // Yotpo's synced metafields stay if this fails.
  function each(selector, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), fn);
  }

  function loadReviews() {
    var source = document.querySelector('[data-lp-yotpo]');
    if (!source || !window.fetch) return;

    var key = source.getAttribute('data-app-key');
    var productId = source.getAttribute('data-product-id');
    if (!key || !productId) return;

    var url = 'https://api-cdn.yotpo.com/v3/storefront/store/' + encodeURIComponent(key) +
      '/product/' + encodeURIComponent(productId) + '/reviews?page=1&perPage=1';

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var bottomline = json && json.bottomline;
        if (!bottomline || !bottomline.totalReview) return;

        var total = Number(bottomline.totalReview);
        var score = (Math.round(Number(bottomline.averageScore) * 10) / 10).toFixed(1);
        var distribution = bottomline.starDistribution || {};

        each('[data-lp-review-score]', function (el) { el.textContent = score; });
        each('[data-lp-review-count]', function (el) { el.textContent = total.toLocaleString('en-US'); });

        each('[data-lp-review-bar]', function (row) {
          var count = Number(distribution[row.getAttribute('data-lp-review-bar')] || 0);
          var fill = row.querySelector('[data-lp-bar-fill]');
          var label = row.querySelector('[data-lp-bar-count]');
          if (fill) fill.style.width = (count / total * 100).toFixed(1) + '%';
          if (label) label.textContent = count.toLocaleString('en-US');
        });
        each('[data-lp-review-bars]', function (el) { el.hidden = false; });
      })
      .catch(function () {});
  }

  /* ---------- Start ---------- */
  function init() {
    initSticky();
    refreshCartState();
    watchCartDrawer();
    loadReviews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is added, changed or removed.
  document.addEventListener('shopify:section:load', function () {
    initSticky();
    refreshCartState();
    loadReviews();
  });
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(initSticky, 0);
  });
})();
